//https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components

import createHistory from 'history/createBrowserHistory';
export default createHistory();



// WEBPACK FOOTER //
// ./js/common/utils/history.js